/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'replace': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(11 9)" _stroke="#00272E"><g transform="translate(1.2)"><path pid="0" d="M5.884 1.386V0"/><path pid="1" d="M1.955 1.386V0"/></g><path pid="2" d="M7.084 4.533v6.058h2.75c.432 0 .536.246.23.546l-4.388 4.317a.792.792 0 01-1.112 0L.176 11.137c-.306-.3-.203-.546.23-.546h2.75V4.533"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/replace.js